import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import CustomLabel from "./CustomLabel";

type Props = {
  form: any;
  name: string;
  label: string;
  placeholder: string;
  bgError?: string;
  textError?: string;
  type?: any;
};

const CustomTextArea = ({
  form,
  name,
  placeholder,
  label,
  bgError,
  textError,
  type,
}: Props) => {
  return (
    <div className="grid w-full items-center gap-1.5">
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FormItem>
            <CustomLabel id={name} label={label} />
            <FormControl>
              <Textarea
                placeholder={placeholder}
                id={field.name}
                {...field}
                className={`${bgError ? bgError : "aria-invalid:bg-red/10"}`}
              />
            </FormControl>
            <FormMessage className={`${textError ? textError : "text-red"}`} />
          </FormItem>
        )}
      />
    </div>
  );
};

export default CustomTextArea;
